import React, { useState, useEffect } from "react";
import { Modal, Form, Input, InputNumber, Select, message, Button } from "antd";
import InventoryUpdateServ from "../service/InventoryUpdateServ";
import ProductServ from "../service/ProductServ";

const { Option } = Select;

const AddInventoryUpdate = ({ open, onClose, refreshInventory }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [products, setProducts] = useState([]);
    const [fetchingProducts, setFetchingProducts] = useState(false);

    useEffect(() => {
        if (open) {
            fetchProducts();
        }
    }, [open]);

    const fetchProducts = async () => {
        try {
            setFetchingProducts(true);
            // Fetch all seller products without pagination for selection
            const response = await ProductServ.getSellerProducts({ limit: 1000 });
            const productsData = response?.data || response?.products || (Array.isArray(response) ? response : []);
            setProducts(productsData);
        } catch (error) {
            console.error("Error fetching products:", error);
            message.error("Failed to load products for selection");
        } finally {
            setFetchingProducts(false);
        }
    };

    const onFinish = async (values) => {
        try {
            setLoading(true);
            const payload = {
                productId: values.productId,
                quantityChange: values.quantityChange,
                reason: values.reason,
                type: "manual"
            };

            await InventoryUpdateServ.addRecord(payload);
            message.success("Inventory updated successfully");
            form.resetFields();
            onClose();
            refreshInventory(true);
        } catch (error) {
            console.error("Error updating inventory:", error);
            message.error(error.message || "Failed to update inventory");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            title="Add Inventory Record"
            open={open}
            onCancel={onClose}
            footer={null}
            destroyOnClose
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                initialValues={{ quantityChange: 0 }}
            >
                <Form.Item
                    name="productId"
                    label="Select Product"
                    rules={[{ required: true, message: "Please select a product" }]}
                >
                    <Select
                        showSearch
                        placeholder="Search and select product"
                        optionFilterProp="children"
                        loading={fetchingProducts}
                    >
                        {products.map((product) => (
                            <Option key={product._id} value={product._id}>
                                {product.name} (Current Stock: {product.stock})
                            </Option>
                        ))}
                    </Select>
                </Form.Item>

                <Form.Item
                    name="quantityChange"
                    label="Quantity Change (use negative for deduction)"
                    rules={[{ required: true, message: "Please enter quantity change" }]}
                >
                    <InputNumber className="pcu-w-100" placeholder="E.g. 10 or -5" />
                </Form.Item>

                <Form.Item
                    name="reason"
                    label="Reason / Note"
                    rules={[{ required: true, message: "Please provide a reason" }]}
                >
                    <Input.TextArea rows={3} placeholder="E.g. Restock from supplier, Damage correction, etc." />
                </Form.Item>

                <Form.Item className="pcu-margin-bottom-0 pcu-text-right">
                    <Button className="pcu-margin-right-8" onClick={onClose}>
                        Cancel
                    </Button>
                    <Button type="primary" htmlType="submit" loading={loading}>
                        Update Inventory
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default AddInventoryUpdate;
